import {
  FETCH_RETAILER_INFO,
  FETCH_RETAILER_INFO_SUCCESS,
  FETCH_RETAILER_INFO_FAILURE,
  FETCH_STORE_INFO,
  FETCH_STORE_INFO_SUCCESS,
  FETCH_STORE_INFO_FAILURE,
  SET_LANGUAGE,
  SET_SESSION_COOKIE,
  SET_STORE_ID
} from './App.actions'

const initialState = {
  selectedLanguage: 'en-us',
  sessionCookie: '',
  centerId: '',
  retailerCode: '',
  retailerId: '',
  retailerLogo: '',
  storeId: '',
  storeName: '',
  isLoading: false,
  errors: []
}

const currentState = (state = initialState, action) => {
  switch(action.type) {
    case SET_LANGUAGE:
      return {
        ...state,
        selectedLanguage: action.payload
      }
    case SET_SESSION_COOKIE:
      return {
        ...state,
        sessionCookie: action.payload
      }
    case SET_STORE_ID:
      return {
        ...state,
        storeId: action.payload
      }
    case FETCH_RETAILER_INFO:
    case FETCH_STORE_INFO:
      return {
        ...state,
        isLoading: true
      }
    case FETCH_RETAILER_INFO_SUCCESS:
      return {
        ...state,
        retailerId: action.payload.retailer_id,
        isLoading: false
      }
    case FETCH_STORE_INFO_SUCCESS:
      return {
        ...state,
        centerId: action.payload.centre_id,
        retailerCode: action.payload.retailer_code,
        retailerLogo: action.payload._links.logo.href,
        storeName: action.payload.name,
        isLoading: false
      }
    case FETCH_RETAILER_INFO_FAILURE:
    case FETCH_STORE_INFO_FAILURE:
      return {
        ...state,
        errors: action.payload,
        isLoading: false
      }
    default:
      return state
  }
}

export default currentState;